import Swiper, { Autoplay, Navigation, Pagination, Keyboard } from 'swiper'
import 'swiper/swiper-bundle.css'
import './styles.scss'

Swiper.use([ Autoplay, Navigation, Pagination, Keyboard ])

const setBrandsSlider = () => {
    const swiper = new Swiper('.brands__slider', {
        direction: 'horizontal',

        autoplay: true,
        delay: 4000,

        slidesPerView: 8,

        loop : true,

        spaceBetween: 10,
        
        navigation: {
            nextEl: '.brands__slider .swiper-button-next',
            prevEl: '.brands__slider .swiper-button-prev',
        },
        pagination: {
            el: '.brands__slider .swiper-pagination',
            clickable: true,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },

        breakpointsBase : 'container',
        breakpoints: {
            0: {
                slidesPerView: 3,
            },

            380: {
                slidesPerView: 4,
            },


            480: {
                slidesPerView: 5,
            },

            620: {
                slidesPerView: 7,
            },

            1050: {
                slidesPerView: 8,
            },
        }
    })
}


const resizeBrandsSlider = () => {
    document.querySelectorAll('.brands__slider-outer').forEach((brandsSliderNode) => {
        brandsSliderNode.style.width = '0px'

        setTimeout(() => {
            brandsSliderNode.style.width = (document.querySelector('.inner').offsetWidth - 40) + 'px'

            setTimeout(() => {
                setBrandsSlider()
            }, 0)
        }, 0)
    })
}

resizeBrandsSlider()
window.addEventListener('resize', resizeBrandsSlider)

setTimeout(() => {
    setBrandsSlider()
}, 0)

const loadMoreSectionsButton = document.querySelector('.button_load-more-sections')

if (loadMoreSectionsButton) {
    loadMoreSectionsButton.addEventListener('click', () => {
        document.querySelectorAll('.happy-brands__sections .happy-brands__section-item.button_hide').forEach((buttonSection) => {
            buttonSection.classList.remove('button_hide')
        })

        loadMoreSectionsButton.remove()
    })
}